import branding from './branding';
import seo from './seo';

export default {
  branding,
  seo,
  components: {
    logo: {
      light: '#FFFFFF',
      dark: '#1927f0',
    },
  },
};
